// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    if(!(window.ActiveXObject) && "ActiveXObject" in window) {
        /*is explorer*/
        function msieversion() {
            let ua = window.navigator.userAgent;
            let msie = ua.indexOf("MSIE ");
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
            {
                const image_fit = document.getElementsByClassName('image-fit__wrapper');
                for(let i = 0; i < image_fit.length; i++ ){
                    const this_image = image_fit[i].getElementsByTagName('img')[0];
                    const image_data = this_image.dataset.srcset;
                    const image_src = this_image.getAttribute('src');
                    image_fit[i].classList.add('ie-bg');
                    if(image_data){
                        image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
                    }else{
                        image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
                    }
                }
            }
            else
            {
                console.log('other browser');
            }
            return false;
        }
        msieversion();

    } else {
        /*****************************************************
        OBSERVER TO ADD PARALLAX EFFECT
        *****************************************************/
        let scrollParallax = []
        let scrolled = 0
        /* screen height */
        let v_height = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;
        function doParallax(elm) {
            let boundes = elm.dataset.parallax.split(",") /* get it from html */
            /*get distance in positive value*/
            let distance = Math.abs(boundes[0] - boundes[1])
            if (boundes[0] > boundes[1]) {
                /*get distance in negative value (to do the scroll inverse)*/
                distance = distance * -1
            }
            /*Equivalent distance using screen height + element height*/
            const unit_scroll = distance / (v_height + elm.offsetHeight)
            let temp = 0
            let topElement = 0;
            let element = elm;
            let id_elem = elm.dataset.parallaxid
            do {
                topElement += element.offsetTop || 0;
                element = element.offsetParent;
            } while (element)
            let parallaxFunction = function () {
                /*Obtain the distance between top screen and document top 0*/
                scrolled = document.documentElement.scrollTop || window.pageYOffset
                /*Distance of bottom page to top of the element*/
                let relative_distance = scrolled + v_height - topElement
                /*transpoling data to move the parallax element relative to the scroll of all the screen*/
                temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
                /*console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)*/
                elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
            }
            scrollParallax[id_elem] = parallaxFunction
            window.addEventListener('scroll', scrollParallax[id_elem])
        }

        let observers_parallax = document.querySelectorAll(".js-parallax-element")

        if (observers_parallax) {
            let options_parallax = {
                root: null, /* relative to document viewport */
                rootMargin: '0px', /* margin around root. Values are similar to css property. Unitless values not allowed */
                threshold: 0 /* visible amount of item shown in relation to root */
            }

            function handler_parallax(entries, observer) {
                let entry;
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        doParallax(entry.target)
                    } else {
                        let id_elem = entry.target.dataset.parallaxid
                        window.removeEventListener('scroll', scrollParallax[id_elem])
                    }
                })
            }

            let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
            let counter = 1
            observers_parallax.forEach(function (element) {
                observable_parallax.observe(element)
                element.dataset.parallaxid = counter
                counter++
            })
        }
        /********************************************************************************
        END OF OBSERVER TO ADD PARALLAX EFFECT
        ***********************************************************************************/
    }

    /* Text and Form Animations */
    let formModule = document.querySelectorAll('.form-module-wrapper form');
    let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
    if(formModule){
        formModule.forEach(function(form_module) {
            form_module.classList.add('animate-fade', 'top');
        });
    }
    if(textModule){
        textModule.forEach(function(text_module) {
            text_module.classList.add('animate-fade', 'top');
        });
    }

    /* Menu Site */
    let Body = document.body;
    let BurgerMenu = document.getElementById('js_btn_menu');
    let NavigationBox = document.getElementById('navigationBox');
    let CloseNav = document.getElementById('js_navigation_close');

    if(BurgerMenu){
        BurgerMenu.addEventListener('click', function(e){
            e.preventDefault();
            NavigationBox.classList.add('open');
            Body.classList.add('scroll-no');
            header.classList.add('open-menu');
        });
    }

    if(CloseNav){
        CloseNav.addEventListener('click', function(e){
            e.preventDefault();
            NavigationBox.classList.remove('open');
            Body.classList.remove('scroll-no');
            header.classList.remove('open-menu');
        });
    }

    document.addEventListener('DOMContentLoaded', () => {

        /* Main Nav Dropdown */
        let primaryNav = document.getElementById('primary-nav');
        if(primaryNav){
            primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
                if(primary_nav.querySelector('ul.submenu')){
                    primary_nav.querySelector('a').classList.add('has-submenu');
                }
                primary_nav.addEventListener("mouseover", (event) => {
                    primary_nav.classList.add('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.add('open');
                    }
                });
                primary_nav.addEventListener("mouseout", (event) => {
                    primary_nav.classList.remove('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.remove('open');
                    }
                });
                primary_nav.querySelectorAll('.has-submenu').forEach(function(parent){
                    parent.addEventListener("click", (event) => {
                        primary_nav.classList.add('hover');
                        if(primary_nav.querySelector('ul.submenu')){
                            document.querySelectorAll('ul.submenu').forEach((submenu)=>{
                                submenu.classList.remove('open');
                            });
                            primary_nav.querySelector('ul.submenu').classList.add('open');
                        }
                    });
                });
            });
        }
        let primaryOneNav = document.getElementById('primary-one-header');
        if(primaryOneNav){
            primaryOneNav.querySelectorAll('li').forEach(function(primary_nav) {
                if(primary_nav.querySelector('ul.submenu')){
                    primary_nav.querySelector('a').classList.add('has-submenu');
                }
                primary_nav.addEventListener("mouseover", (event) => {
                    primary_nav.classList.add('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.add('open');
                    }
                });
                primary_nav.addEventListener("mouseout", (event) => {
                    primary_nav.classList.remove('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.remove('open');
                    }
                });
                primary_nav.querySelectorAll('.has-submenu').forEach(function(parent){
                    parent.addEventListener("click", (event) => {
                        primary_nav.classList.add('hover');
                        if(primary_nav.querySelector('ul.submenu')){
                            document.querySelectorAll('ul.submenu').forEach((submenu)=>{
                                submenu.classList.remove('open');
                            });
                            primary_nav.querySelector('ul.submenu').classList.add('open');
                        }
                    });
                });
            });
        }
        let primaryTwoNav = document.getElementById('primary-two-header');
        if(primaryTwoNav){
            primaryTwoNav.querySelectorAll('li').forEach(function(primary_nav) {
                if(primary_nav.querySelector('ul.submenu')){
                    primary_nav.querySelector('a').classList.add('has-submenu');
                }
                primary_nav.addEventListener("mouseover", (event) => {
                    primary_nav.classList.add('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.add('open');
                    }
                });
                primary_nav.addEventListener("mouseout", (event) => {
                    primary_nav.classList.remove('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.remove('open');
                    }
                });
                primary_nav.querySelectorAll('.has-submenu').forEach(function(parent){
                    parent.addEventListener("click", (event) => {
                        primary_nav.classList.add('hover');
                        if(primary_nav.querySelector('ul.submenu')){
                            document.querySelectorAll('ul.submenu').forEach((submenu)=>{
                                submenu.classList.remove('open');
                            });
                            primary_nav.querySelector('ul.submenu').classList.add('open');
                        }
                    });
                });
            });
        }

        let secondaryNav = document.getElementById('secondary-header-ul_nav');
        if(secondaryNav){
            secondaryNav.querySelectorAll('li').forEach(function(secondary_nav) {
                secondary_nav.addEventListener("mouseover", (event) => {
                    secondary_nav.classList.add('hover');
                    if(secondary_nav.querySelector('ul.submenu')){
                        secondary_nav.querySelector('ul.submenu').classList.add('open');
                    }
                });
                secondary_nav.addEventListener("mouseout", (event) => {
                    secondary_nav.classList.remove('hover');
                    if(secondary_nav.querySelector('ul.submenu')){
                        secondary_nav.querySelector('ul.submenu').classList.remove('open');
                    }
                });
            });
        }

        /* Lightbox Gallerys */
        const customLightbox = new LBX('.js-lbx-gallery', {
            customClass:'lbx-gallery',
        });

        /* Lightbox Gallerys */
        const defaultLightbox = new LBX('.js-lbx-default', {
            beforeShow: function () {
                let lightboxSliders = document.querySelectorAll('.images-l-sliders');
                if(lightboxSliders){
                    lightboxSliders.forEach(()=>{
                        new Swiper('.images-l-sliders', {
                            rewind: true,
                            effect: "fade",
                            fadeEffect: {
                                "crossFade": true
                            },
                            navigation: {
                                nextEl: ".sw-but-img-next",
                                prevEl: ".sw-but-img-prev",
                            },
                        });
                    });
                }
            },
        });

        /* Redirect Selector */
        let selectLocation = document.getElementById('select_location');
        if(selectLocation) {
            selectLocation.addEventListener('change', function(){
                let value = this.value;
                if(value != ""){location.href = value;}
            });
        }

        //email signup animation 
        let emailSingle = document.getElementById('email-signup');
        if(emailSingle){
            let emailSignup = emailSingle.querySelectorAll('input[type=text], input[type=email], input[type=date]');
            for (const input of emailSignup){
                input.addEventListener('focus', function(){
                    console.log('entro al focus');
                    this.parentElement.classList.add('moved');
                })
            }
        }

        //CMS forms label animation
        if(document.getElementsByClassName('form-module__field').length > 0){
            let allFields = document.getElementsByClassName('form-module__field');
            for(let j = 0; j < allFields.length; j++){
                if(allFields[j].getElementsByTagName('input').length > 0){
                    if(allFields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allFields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                        allFields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                            this.parentElement.classList.add('moved');
                        })
                    }
                }
                if(allFields[j].getElementsByTagName('select').length > 0){
                    allFields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
                if(allFields[j].getElementsByTagName('textarea').length > 0){
                    allFields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
        }

    });

    window.addEventListener("load", function() {
        scrollW();
        window.addEventListener('scroll', function(){
            scrollW();
        });
    });

    /* Remove empty <p> tags created by tinymce */
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    /* Scroll Intro*/
    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    /* FAQ */
    let tabLabel = document.querySelectorAll('.tab-label');
    if(tabLabel){
        tabLabel.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    tabLabel.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

    /* Menu Accordion */
    let menuInfo = document.querySelectorAll('.menu-title-info');
    if(menuInfo){
        menuInfo.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    menuInfo.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

    /*MOBILE MENU NAV
    ****************************************************************/

    let Html = document.getElementsByTagName('html')[0];
    let MenuBtn = document.getElementById('menu-btn');
    let CloseMenu = document.querySelectorAll('.close-menu');
    let Navigation = document.querySelectorAll('.navigation');
    let NavUl = document.querySelectorAll('.navigation .inner ul li');
    let NavA = document.querySelectorAll('.navigation .inner ul li a');
    let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

    /* Open Navigation */
    if(MenuBtn){
        MenuBtn.addEventListener('click', function(e){
            Html.classList.add('hide-overflow');
            Navigation[0].classList.add('open');
            NavUl.forEach(function(inner) {
                if(inner.classList.contains('item-open')){
                    inner.scrollIntoView(false);
                }
            });
        });

        /* Sub-Navigation */
        /* Open active sub-nav on load */
        NavActive.forEach(function(inner) {
            inner.closest('.inner').classList.add('open');
            inner.parentNode.parentNode.parentNode.parentNode.classList.add('li-open');
            inner.closest('.sub-sub-menu').classList.add('menu-open');
        });

        /* Toggle open/close on tap */
        NavA.forEach(function(entry) {
            if(entry.nextElementSibling){
                entry.classList.add('link-parent');
                let clientChildren = entry.nextElementSibling.querySelector('.submenu');
                if(clientChildren != null){
                    let clientHeight = clientChildren.clientHeight;
                    if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
                        entry.nextElementSibling.classList.add('menu-open');
                        entry.nextElementSibling.style.height = clientHeight+'px';
                        entry.classList.add('hover-open');
                        entry.parentNode.classList.add('li-open');
                    }
                    entry.addEventListener('click', function(e){
                        e.preventDefault();
                        if(this.nextElementSibling.classList.contains('menu-open')){
                            this.nextElementSibling.classList.remove('menu-open');
                            this.nextElementSibling.style.height = '0px';
                            this.classList.remove('hover-open');
                            this.parentNode.classList.remove('li-open');
                        } else {
                            NavUl.forEach(function(ul) {
                                if(ul.querySelector('.sub-sub-menu')){
                                    if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
                                        ul.querySelector('.sub-sub-menu').style.height = '0px';
                                        ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
                                        ul.querySelector('.link-parent').classList.remove('hover-open');
                                        ul.querySelector('.link-parent').parentNode.classList.remove('li-open');
                                    }
                                }
                            });
                            this.nextElementSibling.classList.add('menu-open');
                            this.nextElementSibling.style.height = clientHeight+'px';
                            this.classList.add('hover-open');
                            this.parentNode.classList.add('li-open');
                        }
                    });
                }
            }
        });
    }

    /* Close Navigation */
    if(CloseMenu[0]){
        CloseMenu[0].addEventListener('click', function(e){
            Html.classList.remove('hide-overflow');
            Navigation[0].classList.remove('open');
        });
    }

    let notCharge = document.querySelectorAll('.not-charge');
    if (notCharge){
        notCharge.forEach(entry => {
            entry.addEventListener('click', function(event){
                event.preventDefault();
            });
        });
    }

    let screenHeight = document.documentElement.clientHeight;
    let homeTopImg = document.getElementById('home');
    if(homeTopImg){
        homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
            if(screen.width < 600){
                entry.style.height = screenHeight-60+'px';
            } else {
                entry.style.height = screenHeight+'px';
            }
        });
        window.addEventListener("resize", function(){
            screenHeight = document.documentElement.clientHeight;
            homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
                if(screen.width < 600){
                    entry.style.height = screenHeight-60+'px';
                } else {
                    entry.style.height = screenHeight+'px';
                }
            });
        });
    }

    let aBtn = document.querySelectorAll(".btn:not(:where(.attractions-map__expand, .btn-form, .book-now)), .signup-btn, .btn-send");
    if(aBtn){
        setTimeout(() => {
            aBtn.forEach(function(a_btn) {
                let htmlString = a_btn.innerText;
                if(htmlString.toLowerCase().includes('(opens in new window)'.toLowerCase())){
                    let result = htmlString.split(/(\([^)]*\))/);
                    a_btn.innerHTML = '<span>'+result[0]+'</span><sup class="hidden">'+result[1]+'</sup>';
                } else {
                    a_btn.innerHTML = '<span>'+htmlString+'</span>';
                }
            });
        }, 500);
    }

    /* Change Languages */
    let selectLan = document.getElementById('languages');
    if(selectLan){
        selectLan.addEventListener('change', (e)=>{
            let lang = e.target.value;
            changeLanguage(lang);
        })
    }

    /* Select Hotel */
    let selectH = document.getElementById('select_h');
    if(selectH){
        let selectedHOption  = selectH.querySelector('.selected-option');
        let selectHValue     = selectH.querySelector('.select-value');
        let optionHContainer = selectH.querySelector('.options');
        let optionHList      = selectH.querySelectorAll('.option');

        /** Toggle function */
        let selectToggle = ()=>{
            if(optionHContainer.dataset.toggle == 'collapsed'){
                optionHContainer.parentElement.classList.add('collapsed');
                optionHContainer.dataset.toggle = '';
            }else{
                optionHContainer.dataset.toggle = 'collapsed';
                optionHContainer.parentElement.classList.remove('collapsed');
            }
        }
        /** When click on seleted-option */
        selectedHOption.addEventListener('click',selectToggle);
        /** This function update select value */
        let updateSelectHValue = (option) => {
            selectHValue.innerText = option.innerText;
        }
        optionHList.forEach((option) => {
            option.addEventListener('click',(e) => {
                window.location = option.dataset.tag;
                updateSelectHValue(option)
                selectToggle();
                optionHList.forEach(el => el.classList.remove('hidden'));
                option.classList.add('hidden');
            })  
        });

    }

    /* Anchor Animation */
    let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-lbx], a[data-filter], a.accordion-toggle, .link-parent, a.skip-to-content))");
    if(aHref){
        aHref.forEach(function(a_href) {
            a_href.addEventListener('click', function(e){
                e.preventDefault();
                let strAnchor = this.hash.slice(1);
                animateto(strAnchor);
            });
        });
    }

    /* Accessibility script for the 'skip to content' link - handles browser focus initialization issues */
    document.addEventListener('DOMContentLoaded', function() {
    const skipLink = document.querySelector('.skip-to-content');
    if (!skipLink) return;

    skipLink.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        const targetEl = document.querySelector(targetId);

        if (targetEl) {
            if (!targetEl.hasAttribute('tabindex')) {
                targetEl.setAttribute('tabindex', '-1');
            }
            targetEl.focus();
        }
    });

            document.documentElement.setAttribute('tabindex', '-1');
            window.addEventListener('keydown', function handleFirstTab(e) {
                    if (e.key === 'Tab') {
                            if (document.activeElement === document.body || document.activeElement === document.documentElement) {
                                    e.preventDefault();
                                    skipLink.focus();
                                    window.removeEventListener('keydown', handleFirstTab);
                            }
                    }
            }, true);
    });
})();

function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 160;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    /* Time Interval */
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
/* ScrollW */
function scrollW(){
    /* check scroll down or up for header styles */
    let st = window.pageYOffset || document.documentElement.scrollTop;
    let header = document.getElementById('header');
    if(st > 80){
        if (st > lastScrollTop){
            /* downscroll code */
            if(!header.classList.contains('down')){
                header.classList.add('down');
                header.classList.remove('up');
            }
        } else {
            /* upscroll code */
            if(!header.classList.contains('up')){
                header.classList.add('up');
                header.classList.remove('down');
            }
        }
    } else {
        if(header.classList.contains('up') || header.classList.contains('down')){
            header.classList.remove('up');
            header.classList.remove('down');
        }
    }

    //let SubMenu = document.getElementById('subMenuAnchor');

    // if(SubMenu){
    //  let subPost = document.getElementById('subMenu');
    //  let subPosition = '';
    //  if(document.body.classList.contains('alert_open')){
    //      subPosition = offset(SubMenu).top - 146;
    //  } else {
    //      if(screen.width < 600){
    //          subPosition = offset(SubMenu).top - 68;
    //      } else {
    //          subPosition = offset(SubMenu).top - 116;
    //      }
    //  }
    //  if(st > 80){
    //      if(!subPost.classList.contains('floating-up')){
    //          subPost.classList.add('floating-up');
    //      }
    //  } else {
    //      if(subPost.classList.contains('floating-up')) {
    //          subPost.classList.remove('floating-up');
    //      }
    //  }
    // }

    lastScrollTop = st <= 0 ? 0 : st; /* For Mobile or negative scrolling */

}
// Delete the role if the container is empty in the menu
document.addEventListener('DOMContentLoaded', () => {
    const menusItems = document.querySelectorAll('.menus-items');
    menusItems.forEach(item => {
        if (item.children.length === 0 || item.getAttribute('aria-hidden') === 'true') {
            item.removeAttribute('role');
            item.setAttribute('aria-hidden', 'true');
        }
    });
});

//Mobile when the menu option has an #
document.addEventListener('DOMContentLoaded', () => {
    const anchorLinks = document.querySelectorAll('a[href*="#"]');
    anchorLinks.forEach(link => {
        link.addEventListener('click', () => {
            const navOverlay = document.querySelector('.navigation.overlay');
            if (navOverlay) navOverlay.classList.remove('open');
            document.body.style.overflow = 'auto';
            document.documentElement.style.overflow = 'auto';
        });
    });
});